module.exports = __webpack_public_path__ + "static/media/success.37b6bc65.png";